module.exports = __webpack_public_path__ + "tables/media/Forms_filled.dd194edc.svg";